import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Toggle } from '../../../../../CommonComponents/OPL/Toggle/Toggle';
import { MarginProps } from '../../../../../theme/styledProps';
import { SectionHeader } from '../../../FirmSettings/components/SectionHeader/SectionHeader';
import { FormValues } from '../../MySettings.meta';

interface Props extends MarginProps {
  formBag: UseFormReturn<FormValues>;
}

export const BeFi20: React.FC<Props> = ({ formBag, ...rest }) => {
  return (
    <Box as="section" {...rest}>
      <SectionHeader title="BeFi20" />

      <Toggle {...formBag.register('allowBeFi20Adviser')}>
        Turn on BeFi20 by default for all clients
      </Toggle>
    </Box>
  );
};
